import baseSpotRecordDetails from '../../base/baseSpotRecordDetails';
import appMapStationCapabilitesAllowed from './appMapStationCapabilitesAllowed'

export default (urlParameters) => {
  return {
    allowedStationCapabilities: appMapStationCapabilitesAllowed,
    spotRecordDetail: baseSpotRecordDetails
  }
}